import { CEIngestAttributesBase } from './ce-ingest-attributes-base'


export class CEIngestAttributes extends CEIngestAttributesBase {

}